export default class InputGetOperationsCost
{
  constructor(startTime, endTime, task, place, person, tool) 
  {
    this.startTime = startTime;
    this.endTime = endTime;
    this.task = task;
    this.place = place;
    this.person = person;
    this.tool = tool;
  }    
}